export function timer(now) {
    var st = now();
    return function stop() {
        return Math.round(now() - st);
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/utils/timeTracker/timer.js
// module id = 603
// module chunks = 31